import { IDataCollection } from "../../interfaces/base/ITable";
import { IBaseFilter, Ifilter } from "../../interfaces/IFilter";
import { ICrearLugarMovilizacionHorarioCommand, IEditarLugarMovilizacionHorarioCommand, IListarLugarMovilizacionHorarioDto } from "../../interfaces/ILugarMovilizacionHorario";
import {
  IRequestAsignarEmpresa,
  IRequestEliminarEmpresa,
  IUbicacionCommand,
  IUbicacionDTO,
} from "../../interfaces/ubicacion/IUbicacion";
import { fetchMovilizacion } from "../http-common";

const urlLugarMovilizacion = "LugarMovilizacion";

const ComboLugar = () => {
  return fetchMovilizacion.get(`${urlLugarMovilizacion}`);
};

const ComboLugarMovilizacion = () => {
  return fetchMovilizacion.get<{ key: string; text: string }>(
    `${urlLugarMovilizacion}/Combo`
  );
};

const CrearLugarMovilizacion = (request: IUbicacionCommand) => {
  return fetchMovilizacion.post(`${urlLugarMovilizacion}`, request);
};

const ListarUbicacion = (
  filter: Ifilter,
  controller = new AbortController()
) => {
  return fetchMovilizacion.get(`${urlLugarMovilizacion}/Tabla`, {
    params: filter,
    signal: controller.signal,
  });
};

const EditarLugarMovilizacion = (request: IUbicacionDTO) => {
  return fetchMovilizacion.put(`${urlLugarMovilizacion}`, request);
};

const EliminarLugarMovilizacion = (lugarMovilizacionId: string) => {
  return fetchMovilizacion.delete(`${urlLugarMovilizacion}`, {
    params: { lugarMovilizacionId },
  });
};

const EliminarEstadoLugarMovilizacion = (lugarMovilizacionId: string) => {
  return fetchMovilizacion.delete(`${urlLugarMovilizacion}/Eliminar`, {
    params: { lugarMovilizacionId },
  });
};

const EliminarLugarMovilizacionEmpresa = (request: IRequestEliminarEmpresa) => {
  if (!request.empresaId || !request.lugarMovilizacionId) {
    throw new Error(
      "Los campos empresaId y lugarMovilizacionId son requeridos."
    );
  }

  return fetchMovilizacion.delete(
    `${urlLugarMovilizacion}/eliminarMovilizacionEmpresa`,
    {
      params: request,
    }
  );
};

const ListarMovilizacionEmpresa = (LugarMovilizacionId: any) => {
  return fetchMovilizacion.get(`${urlLugarMovilizacion}/movilizacionEmpresa`, {
    params: { LugarMovilizacionId },
  });
};

const AsignarMovilizacionEmpresa = (request: IRequestAsignarEmpresa) => {
  return fetchMovilizacion.post(
    `${urlLugarMovilizacion}/asignarLugarMovilizacion`,
    request
  );
};

const ListarLugaresMovilizacionHorarios = (filter: IBaseFilter, controller = new AbortController()) => {
  return fetchMovilizacion.get<
    IDataCollection<IListarLugarMovilizacionHorarioDto>
  >(`${urlLugarMovilizacion}/Horarios/Configuracion`, {
    params: filter,
    signal: controller.signal
  });
};

const CrearLugarMovilizacionHorario = (command: ICrearLugarMovilizacionHorarioCommand) => {
  return fetchMovilizacion.post(`${urlLugarMovilizacion}/Horarios`, command);
};

const EditarLugarMovilizacionHorario = (command: IEditarLugarMovilizacionHorarioCommand) => {
  return fetchMovilizacion.put(`${urlLugarMovilizacion}/Horarios`, command);
};

const EliminarLugarMovilizacionHorario = (command: { lugarMovilizacionHorarioId: string }) => {
  return fetchMovilizacion.delete(`${urlLugarMovilizacion}/Horarios`, {
    data: command
  });
};

const LugarMovilizacionService = {
  ComboLugar,
  ComboLugarMovilizacion,
  ListarUbicacion,
  EliminarLugarMovilizacion,
  EditarLugarMovilizacion,
  CrearLugarMovilizacion,
  ListarMovilizacionEmpresa,
  AsignarMovilizacionEmpresa,
  EliminarLugarMovilizacionEmpresa,
  EliminarEstadoLugarMovilizacion,
  ListarLugaresMovilizacionHorarios,
  CrearLugarMovilizacionHorario,
  EditarLugarMovilizacionHorario,
  EliminarLugarMovilizacionHorario
};

export { LugarMovilizacionService };
